import { useState, useEffect } from "react";
import axios from "axios";
import { getUserLocale, getUserLocales } from "get-user-locale";
import getSubdomain from "../../utils/getSubdomain";

const useGetContract = () => {
  const [contractHtml, setContractHtml] = useState(null);
  const [loading, setLoading] = useState(false);

  const [subDomain] = useState(getSubdomain());

  const getContract = async () => {
    setLoading(true);

    if (!subDomain) {
      return;
    }

    const userLocale = getUserLocale();
    const userLocales = getUserLocales();
    // console.log("userLocale:", userLocale, "| userLocales:", userLocales);

    let locale = userLocale && userLocale.substring(0, 2);
    if (!["en", "it"].includes(locale)) {
      locale = "en";
    }

    try {
      await axios
        .get(
          `${process.env.REACT_APP_API}/contracts?locale=${locale}&type=${subDomain}`
        )
        .then((res) => {
          if (res?.data?.data?.content) {
            setContractHtml(res.data.data.content);
          }
        });
    } catch (error) {
      console.log("error", error);
      const enMsg = "<div><p>Oops</p><p>Something went wrong</p></div>";
      const itMsg =
        "<div><p>Oops</p><p>Ops! Qualcosa non ha funzionato</p></div>";
      const errorMsg = locale === "it" ? itMsg : enMsg;

      setContractHtml(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    subDomain && getContract();
  }, [subDomain]);

  return { loading, contractHtml };
};

export default useGetContract;
